export default __webpack_public_path__ + "static/areti-rapakousios-1-36f99ff840baa4fbbf6cbe63c040edc0.webp";